import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FiPhoneCall } from "react-icons/fi";
import { MdOutlineDesignServices } from "react-icons/md";
import { TbTruckDelivery, TbBrandCashapp } from "react-icons/tb";
import { BiPackage, BiCheckCircle } from "react-icons/bi";
import { HiNewspaper } from "react-icons/hi2";
import { FaCartPlus } from "react-icons/fa";
import { RiMoneyDollarCircleFill } from "react-icons/ri";

import numberOne from "../../Assets/numbers/number-1.svg";
import numberTwo from "../../Assets/numbers/number-2.svg";
import numberThree from "../../Assets/numbers/number-3.svg";
import numberFour from "../../Assets/numbers/number-4.svg";
import numberFive from "../../Assets/numbers/number-5.svg";
import numberSix from "../../Assets/numbers/number-6.svg";
import numberSeven from "../../Assets/numbers/number-7.svg";
import numberEight from "../../Assets/numbers/number-8.svg";

function Service() {

  
  const serviceSteps = [
    {
      number: numberOne,
      title: "Discuss Requirements",
      icon: <MdOutlineDesignServices />,
      description: "Connect with us to outline your product specifications, timeline, and quantity needs."
    },
    {
      number: numberTwo,
      title: "Quotation",
      icon: <FaCartPlus />,
      description: "We prepare a tailored quote after consulting with our trusted network of factories."
    },
    {
      number: numberThree,
      title: " Order Confirmation",
      icon: <HiNewspaper />,
      description: "Approve the design and order details to proceed. Custom designs may require initial sampling."
    },
    {
      number: numberFour,
      title: "Deposit Payment",
      icon: <RiMoneyDollarCircleFill />,
      description: "Confirm your order with a deposit to begin production."
    },
    {
      number: numberFive,
      title: "Production",
      icon: <BiPackage />,
      description: "Your products are manufactured, with timelines typically ranging from 3 to 5 weeks."
    },
    {
      number: numberSix,
      title: "Quality Control",
      icon: <BiCheckCircle />,
      description: "Our team performs thorough quality checks near the end of production to ensure all specifications are met."
    },
    {
      number: numberSeven,
      title: "Balance Payment",
      icon: <TbBrandCashapp />,
      description: "Upon your satisfaction with the production results, the balance payment is completed to prepare for shipment."
    },
    {
      number: numberEight,
      title: "Shipping & Storage",
      icon: <TbTruckDelivery />,
      description: "Orders are shipped via sea or air cargo. We also offer warehouse storage to consolidate shipments if needed."
    },
  ];

  return (
    <div className="service">
      <Container fluid className="service-page page-top-settings">
        <Container>
          <Row style={{ textAlign: "center" }}>
            <h2 className="page-title">
              Our Service
              <p>Seamless Sourcing Process</p>
            </h2>
          </Row>
          <Row>
            {serviceSteps.map((step, index) => (
              <Col md={3} sm={6} xs={12} key={index} className={`mb-4 d-flex align-items-stretch ${index === serviceSteps.length ? 'align-self-start' : ''}`}>
                <Card className="service-card w-100">
                  <Card.Body>
                    <div className="card-top">
                      <img src={step.number} alt={`Step ${index + 1}`} className="step-number" />
                      <div className="step-icon">{step.icon}</div>
                    </div>
                    <Card.Title className="step-title">{step.title}</Card.Title>
                    <div className="step-description">
                      {step.description}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Row style={{ justifyContent: "center" }}>
            <a href="tel:614-906-5129" className="btn call-us dark-bg rounded-pill py-md-3 px-md-5 mt-4">
              <FiPhoneCall />&nbsp;&nbsp;Call Us For More Info
            </a>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default Service;
